export default {
  title: "Hub d'interactions",
  addMessage: 'Ajouter un message',
  loading: 'Chargement...',
  quote_load_error: "La soumission du projet n'a pas pu être chargée. Veuillez réessayer.",
  noInteractions: 'Aucune interaction pour le moment',
  loadMore: 'Charger plus',
  messageFrom: 'Message de {{name}}',
  yourMessage: 'Votre message',
  documentAdded: '{{name}} a ajouté un document',
  submitMessage: 'Envoyer',
  attachFile: 'Joindre un fichier',
  messagePlaceholder: 'Écrivez votre message...',
  messageOrAttachmentRequired: 'Veuillez écrire un message ou joindre un fichier',
  fileTooLarge: 'La taille du fichier ne doit pas dépasser 50 Mo',
  viewHub: 'Voir les détails',
  interactionTypes: {
    new_job_posted: 'Projet publié',
    quote_request_received: 'Demande de soumission envoyée',
    quote_request_received_recruiter: 'Demande de soumission envoyée',
    quote_request_received_freelancer: 'Demande de soumission reçue',
    quote_request_received_sent: 'Demande de soumission envoyée',
    quote_request_received_received: 'Demande de soumission reçue',
    quote_submitted: 'Devis du pigiste reçu',
    quote_submitted_sent: 'Devis envoyé',
    quote_submitted_received: 'Devis du pigiste reçu',
    child_quote_submitted: "Devis de l'alliance reçu",
    child_quote_submitted_sent: "Devis de l'alliance envoyé",
    child_quote_submitted_received: "Devis de l'alliance reçu",
    child_quote_accepted: "Devis de l'alliance accepté",
    quote_accepted: 'Soumission acceptée, le projet est démarré',
    quote_change_requested: 'Demande de modification de soumission',
    quote_change_requested_sent: 'Demande de modification de soumission envoyée',
    quote_change_requested_received: 'Demande de modification de soumission reçue',
    adjustment_submitted: 'Ajustement du projet envoyé',
    adjustment_submitted_sent: 'Modification de la soumission envoyée',
    adjustment_submitted_received: 'Soumission modifiée',
    adjustment_title: 'Mon ajustement',
    hub_message: 'Message',
    project_status_updated: 'Statut du projet mis à jour',
    project_completed: 'Projet terminé',
    project_cancelled: 'Projet annulé',
    message_from: 'Message de {{name}}',
    parent_quote_submitted: 'Soumission envoyée au recruteur',
    parent_quote_accepted: 'Le recruteur a accepté votre soumission',
    new_contact_added: 'Nouveau contact créé',
    quote_request_accepted: 'Demande de soumission acceptée',
    quote_alliance_accepted: 'Invitation au projet acceptée',
    quote_alliance_rejected: 'Invitation au projet rejetée',
    quote_alliance_retired: 'Invitation au projet retirée',
    quote_alliance_invited: 'Invitation au projet reçue',
    quote_alliance_invited_sent: 'Invitation au projet envoyée',
    quote_alliance_invited_received: 'Invitation au projet reçue',
    job_selection_period_started_for_applicant: 'Révision des soumissions commencée',
  },
  submission_tracking: 'Suivi des soumissions',
  interaction_history: 'Historique des échanges avec les pigistes',
  project_tracking: 'Suivi du projet',
  project_interaction_history: 'Historique des interactions',
  submission_type_list: {
    direct_request: 'Demande directe',
    received_application: 'Candidature reçue',
  },
  submission_type_title: 'Type de candidature',
  offer: 'Offre',
  received_date: 'Date de réception',
  team: 'Équipe',
  contacts: 'Contacts',
  project_details: 'Détails du projet',
  job_description: 'Description du projet',
  noSubmissionTracking: "Il n'y a aucune soumission pour le moment",
  oneOfferHide: '1 offre masquée',
  multipleOffersHide: '{{count}} offres masquées',
  acceptedOffer: 'Offre retenue',
  principal_freelancer: 'Pigiste principal',
  total: 'Grand Total',
  see_details: 'Voir les détails',
  quote_accepted: 'Soumission acceptée',
  quote_rejected: 'Soumission rejetée',
  quote_pending: 'Soumission en attente',
  no_history: "Il n'y a aucune interaction pour le moment",
  time_ago: {
    just_now: "À l'instant",
    seconds_ago: 'Il y a {{count}} secondes',
    a_minute_ago: 'Il y a une minute',
    minutes_ago: 'Il y a {{count}} minutes',
    an_hour_ago: 'Il y a une heure',
    hours_ago: 'Il y a {{count}} heures',
    a_day_ago: 'Il y a un jour',
    days_ago: 'Il y a {{count}} jours',
    a_week_ago: 'Il y a une semaine',
    weeks_ago: 'Il y a {{count}} semaines',
    a_month_ago: 'Il y a un mois',
    months_ago: 'Il y a {{count}} mois',
    a_year_ago: 'Il y a un an',
    years_ago: 'Il y a {{count}} ans',
  },
  new_label: 'Nouveau',
  Alliances: 'Alliances',
  submission_accepted_hint: 'Soumission de {{name}} acceptée, le projet est démarré',
  quoteSnapshot: {
    title: 'Montant total de la soumission',
    teamSectionLabel: "Soumissions de l'équipe",
    teamMemberLabel: "Membre de l'équipe",
  },
  role: {
    principal: 'Pigiste principal',
    alliance: 'Alliance',
  },
} as const;
